module.exports = __webpack_public_path__ + "static/img/project1.cfe38e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project1.png
// module id = HC0L
// module chunks = 1